import React from "react";
import { connect } from "react-redux";
import { sortColumn } from "../../actions";
import tableDataSelector from "../../selectors/selected_table_data";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Tooltip from "@material-ui/core/Tooltip";

const styles = theme => ({});

class DataTableHead extends React.Component {
  constructor(props) {
    const { order, orderBy } = props;
    super(props);

    this.state = {
      order,
      orderBy
    };
  }

  componentDidMount() {
    const { order, orderBy, data, sortColumn } = this.props;
    sortColumn(data, orderBy, order);
    this.setState({
      order,
      orderBy
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { order, orderBy, data, sortColumn } = this.props;
    const { order: prevOrder, orderBy: prevOrderBy, data: prevData } = prevProps;

    if (order !== prevOrder || orderBy !== prevOrderBy || data.length !== prevData.length) {
      sortColumn(data, orderBy, order);
      this.setState({
        order,
        orderBy
      });
    }
  }

  handleSort = orderBy => () => {
    const { table: { sort: { order } }, data, sortColumn } = this.props;
    const newOrder = order === "asc" ? "desc" : "asc";
    this.setState({
      order: newOrder,
      orderBy
    });
    sortColumn(data, orderBy, newOrder);
  };

  render() {
    const { columns } = this.props;
    const { order, orderBy } = this.state;

    return (
      <TableHead>
        <TableRow>
          {columns.map(column => {
            return (
              <TableCell
                key={column.key}
                numeric={column.numeric}
                padding={column.disablePadding ? "none" : "default"}
                sortDirection={orderBy === column.key ? order : false}
              >
                <Tooltip
                  title="Sort"
                  placement={column.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.key}
                    direction={order}
                    onClick={this.handleSort(column.key)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }
}

DataTableHead.propTypes = {
  columns: PropTypes.array.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  return {
    data: tableDataSelector(state),
    table: state.table
  };
};
export default withStyles(styles)(
  connect(
    mapStateToProps,
    { sortColumn }
  )(DataTableHead)
);



// WEBPACK FOOTER //
// ./src/components/table/DataTableHead.js